<template>
  <div>
    <!-- 加载中 -->
    <div v-if="!url" class="loading-mask-container">
      <div class="loading-icon-wrapper">
        <img src="/static/image/rotate.963673.png" alt="" class="loading-rotate-img" />
      </div>
    </div>

    <!-- 内容区 -->
    <div
      v-else
      class="content-container"
    >
      <iframe
        ref="iframe"
        id="iframe"
        frameborder="0"
        scrolling="auto"
        style="height: 100%; width: 100%"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "gamePage",
  data() {
    return {
      url: null,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;

    if (query.dailiD) {
      if (query.dailiD == 1) {
        that.$apiFun.get("/api/getAgentLoginUrl", {}).then((res) => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        });
        return;
      } else {
        that.$apiFun.post("/api/getservicerurl", {}).then((res) => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        });
      }
    }

    if (query.name) {
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    goGamePage(name, type, code) {
      let that = this;
      that.$apiFun
        .post("/api/getGameUrl", {
          plat_name: name,
          game_type: type || 0,
          game_code: code,
          is_mobile_url: 1,
        })
        .then((res) => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        })
        .catch(() => {});
    },
  },
  updated() {
    if (this.url && this.$refs.iframe) {
      this.$refs.iframe.contentWindow.location.replace(this.url);
    }
  },
};
</script>

<style lang="scss" scoped>
/* 白色背景的 Loading 容器 */
.loading-mask-container {
  background-color: #fff; /* 白色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 50px);
}

.loading-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-rotate-img {
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

/* 旋转动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 内容容器保持白色背景 */
.content-container {
  height: calc(100vh - 50px);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/main/gamePage.vue